import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-one-col-area-nobutton',
  templateUrl: './one-col-area-nobutton.component.html',
  styleUrls: ['./one-col-area-nobutton.component.css']
})
export class OneColAreaNobuttonComponent implements OnInit {

  @Input() oneColAreaNoButton_params: any = {}
  constructor() { }

  ngOnInit(): void {
  }

}
